<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openEditMarqueeDialog(true)"
      >添加任务</el-button
    >

    <el-table :data="marqueeList" border size="small" style="width: 1021px">
      <el-table-column
        prop="text"
        label="文本"
        align="center"
        width="400"
        show-overflow-tooltip
      />
      <el-table-column
        prop="priority"
        label="优先级"
        align="center"
        width="60"
      />
      <el-table-column label="循环播报时间" align="center" width="150">
        <template slot-scope="scope">
          <span
            ><a
              :href="`https://crontab.guru#${scope.row.repeatSpec.replace(
                /\s/g,
                '_'
              )}`"
              target="_blank"
              style="color: blue"
              >{{ scope.row.repeatSpec }}</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column label="有效期起始时间" align="center" width="130">
        <template slot-scope="scope">
          <span>{{ ms2ymdhm(scope.row.validateFromWhen) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="有效期结束时间" align="center" width="130">
        <template slot-scope="scope">
          <span>{{ ms2ymdhm(scope.row.validateToWhen) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            @click="deleteMarquee(scope.row.id, scope.row.name)"
            >删除</el-button
          >
          <el-button
            type="primary"
            round
            size="mini"
            @click="openEditMarqueeDialog(false, scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- “编辑分区”对话框 -->
    <EditMarqueeDialog
      v-if="shouldEditMarqueeDialogVisible"
      @close="onEditMarqueeDialogClosed()"
      :value="valueForEditMarqueeDialog"
    >
    </EditMarqueeDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import EditMarqueeDialog from "./EditMarqueeDialog";

export default {
  data() {
    return {
      shouldEditMarqueeDialogVisible: false, // “添加跑马灯任务”对话框是否应该显示出来
      valueForEditMarqueeDialog: null, // 要传递给“编辑跑马灯任务”对话框的数据
      marqueeList: [], // 列表里展示的数据
    };
  },

  created() {
    // 拉取跑马灯定时任务集合
    this.loadMarqueeScheduleList();
  },

  components: {
    EditMarqueeDialog,
  },

  methods: {
    /**
     * 查询跑马灯定时任务集合
     */
    async loadMarqueeScheduleList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryMarqueeScheduleList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.entries || [];

      // 排序（按id倒序排列）
      listInResponse.sort((x, y) => {
        return y.id - x.id;
      });

      this.marqueeList = listInResponse;
    },

    /**
     * 删除一个条目
     * @param {*} id
     */
    async deleteMarquee(id) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/deleteMarqueeSchedule`,
            {
              id: id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.marqueeList.length; i++) {
          if (this.marqueeList[i].id == id) {
            this.marqueeList.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    /**
     * 打开“编辑跑马灯”对话框
     */
    async openEditMarqueeDialog(isCreate, oldData) {
      this.shouldEditMarqueeDialogVisible = true;
      this.valueForEditMarqueeDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “编辑跑马灯”对话框关闭了
     */
    async onEditMarqueeDialogClosed() {
      this.shouldEditMarqueeDialogVisible = false;

      // 重新拉取跑马灯定时任务集合
      return this.loadMarqueeScheduleList();
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
  },
};
</script>